const COOKIES = {
  browserCookieId: 'BrowserCookieId',
  city: 'CVCurrentCity',
  dismissedEVBanner: 'merch-dismissed-ev-banner',
  dismissedNewPriceBanner: 'merch-dismissed-new-price-banner',
  featureBranchEnabled: 'carvana-merch-serenity-ui',
  featureBranchName: 'carvana-merch-serenity-ui-feature-name',
  hasAppliedTrade: 'merch-tradein-applied',
  idToken: 'CVIdToken',
  nativeAppCapabilities: 'X-CVNA-AppCapabilities-SRP',
  nativeAppVersion: 'X-CVNA-AppVersion',
  partnerId: 'CVActivePartnerId',
  removeFooter: 'srch-remove-footer',
  session: 'mdt-session-id',
  state: 'CVCurrentState',
  verboseLogging: 'merch-verbose-logging',
  zip: 'CVCurrentZip'
};

export default COOKIES;
